<script setup lang="ts">
import type { IProps } from './wellbeing-sale--possibilities.types'
defineProps<IProps>()
</script>

<template>
  <section class="possibilities">
    <div class="possibilities__container">
      <h3 class="possibilities__title">
        {{ $t('wellbeingSale.possibilities.title') }}
      </h3>
  
      <p class="possibilities__subtitle">
        {{ $t('wellbeingSale.possibilities.subtitle') }}
      </p>
  
      <div class="possibilities__graph">
        <div class="possibilities__boxGraph">
          <img
            class="possibilities__imgGraph"
            src="/images/wellbeing-sale/possibilities/graph.svg"
            alt=""
            title=""
          >
          <p class="possibilities__boxText">
            {{ $t('wellbeingSale.possibilities.boxText') }}
          </p>
        </div>
      </div>
  
      <div class="possibilities__donut">
        <div class="possibilities__boxDonut">
          <img
            class="possibilities__img"
            src="/images/wellbeing-sale/possibilities/donut.svg"
            alt=""
            title=""
          >
        </div>
      </div>
  
      <img
        class="possibilities__brain"
        src="/images/wellbeing-sale/possibilities/brain.svg"
        alt=""
        title=""
      >
  
      <p class="possibilities__paragraph">
        {{ $t('wellbeingSale.possibilities.paragraph') }}
      </p>
  
      <UiButton
        class="possibilities__button"
        size="big"
        :to="hookTo"
      >
        {{ $t('wellbeingSale.possibilities.button') }}
      </UiButton>
    </div>
  </section>
</template>

<style lang="scss">
.possibilities {
  padding: 5rem 1.6rem;
  background-color: $purple-50;
  
  &__container {
    position: relative;
    max-width: 132rem;
    margin: auto;
  }

  &__title {
    @include h7;
    padding-bottom: 1.6rem;
    color: $text-400;
    text-align: center;
  }

  &__subtitle {
    @include body-1-medium;
    padding-bottom: 1.6rem;
    color: $text-400;
    text-align: center;
  }
  
  &__paragraph {
    @include body-2-medium;
    padding-bottom: 3.2rem;
    color: $text-400;
    text-align: center;
  }

  &__brain {
    display: block;
    margin: auto;
    padding-bottom: 2.6rem;
  }

  &__graph {
    position: absolute;
    top: 41%;
    left: 1.6rem;
    display: flex;
    display: none;
    max-width: 132rem;
    width: 100%;
  }

  &__donut {
    position: absolute;
    top: 36%;
    right: 1.6rem;
    display: flex;
    display: none;
    justify-content: flex-end;
    max-width: 132rem;
    width: 100%;
  }

  &__boxDonut {
    display: flex;
    width: 8rem;
    height: 8rem;
    padding: .8rem;
    background-color: $white;
    border-radius: .8rem;
    filter: drop-shadow(0 2.4rem 4rem rgba(0, 0, 0, 0.10));
  }

  &__boxGraph {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 12rem;
    height: 12rem;
    background-color: $white;
    border-radius: .8rem;
    box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.10);
  }

  &__boxText {
    @include body-4-medium;
    color: $text-400;
  }

  &__imgGraph {
    display: flex;
    width: 8rem;
    height: 8rem;
  }

  &__button {
    margin: auto;
  }

  @include atXS {
    &__subtitle {
      width: 70%;
      margin: auto;
    }

    &__paragraph {
      width: 60%;
      margin: auto;
    }

    &__donut {
      top: 10%;
    }

    &__graph {
      top: 46%;
    }
  }

  @include atS {
    &__graph {
      display: flex;
    }

    &__donut {
      display: flex;
    }

    &__boxDonut {
      width: 16rem;
      height: 16rem;
    }

    &__boxGraph {
      width: 18rem;
      height: 18rem;
    }

    &__imgGraph {
      width: 12rem;
      height: 12rem;
    }
  }

  @include atM {
    padding: 10rem 0;

    &__title {
      @include h5;
      padding-bottom: 3.2rem;
    }

    &__subtitle {
      @include body-1-medium;
      width: 50%;
      padding-bottom: 3.2rem;
    }

    &__paragraph {
      @include h9;
      width: 50%;
      padding-bottom: 6.4rem;
    }
  }

  @include atL {
    &__boxGraph {
      width: 16rem;
      height: 16rem;
      padding: 1.6rem;
    }

    &__imgGraph {
      height: 13rem;
    }

    &__boxDonut {
      width: 20rem;
      height: 20rem;
    }
  }
}
</style>
